// src/components/data-display/DataTileRealBlockTime.jsx
import { SingleDataValue } from '../data-display';
import { ThemedFlex } from '../../theme/ThemedFlex';
import { useMetrics } from '../../contexts/MetricsContext';

export const DataTileRealBlockTime = ({ formatNumber, animate }) => {
  // Canonical value is the difficulty-epoch-to-date average (mempool timeAvg),
  // matching mempool.space.
  const { raw } = useMetrics();

  const avgBlockTime = raw.avgBlockTime != null
    ? `~${formatNumber(raw.avgBlockTime / 60, 1)} Mins`
    : '';

  return (
    <ThemedFlex
      direction="column"
      mb="12px"
      py="18px"
      px="20px"
      flex={1}
      borderRadius={3}
      className={animate ? 'gray-border-custom gray-border' : ''}
    >
      <SingleDataValue label="Avg Blk Time" value={avgBlockTime} />
    </ThemedFlex>
  );
};